import { useTranslation } from "react-i18next";

import { BATCH_SIZES } from "~/shared/lib/design-tokens";

import { TileSection } from "./TileSection";

interface BatchSizeSectionProps {
    batchSize: number;
    /** Сколько результатов отдаст режим за одну генерацию (1 — пакета нет). */
    maxBatchSize: number;
    onSelect: (value: number) => void;
}

/**
 * Размер пакета — ось со своим потолком у каждой пары «модель × провайдер».
 *
 * Плитку сверх потолка блокируем и говорим, почему: цена на пакет, который
 * никто не исполнит, честно отказывает, и без причины человек увидел бы вместо
 * объяснения ошибку цены. Недоступное при этом остаётся на месте — прятать
 * плитки значило бы менять их набор от модели к модели молча.
 */
export function BatchSizeSection({ batchSize, maxBatchSize, onSelect }: BatchSizeSectionProps) {
    const { t } = useTranslation("chat-settings");
    const noBatchAtAll = maxBatchSize === 1;
    // Тултип виден не всем (тач-экран), поэтому «пакета нет вовсе» проговаривается
    // ещё и подписью секции — это состояние касается всех плиток сразу.
    const reason = noBatchAtAll ? t("batchUnsupported") : t("batchCeiling", { count: maxBatchSize });

    return (
        <TileSection
            label={t("batchSize")}
            hint={noBatchAtAll ? reason : undefined}
            options={BATCH_SIZES}
            active={batchSize}
            onSelect={onSelect}
            renderLabel={(size) => `${size}`}
            wrap={false}
            isDisabled={(size) => size > maxBatchSize}
            disabledHint={reason}
        />
    );
}
